import ContentList from 'app/ui-components/ContentList/ContentList';
import { fromJS } from 'immutable';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import env from '../../../app/env';
import { deleteContinueWatchingListContents } from '../../actions/continueWatching';
import {
    continueWatchingActiveSelector,
    continueWatchingItemsSelector,
} from '../../reducers/continueWatching.js';
import { transformToContentList } from '../../utils/contentoUtils';
import { createListTrackingOnClick } from '../../utils/statistics/clientStatistics';
import { PlaceHolder } from '../../ui-components/PlaceHolder/PlaceHolder';
import fetchContinueWatchItems from '../StartPage/FetchContinueWatchItems';

const ContinueWatchingList = ({
    useTitle,
    continueWatchingItems,
    continueWatchingIsActive,
    deleteContinueWatchingListItems,
}) => {
    let history = null;

    if (continueWatchingItems && continueWatchingItems.size !== 0) {
        history = continueWatchingItems
            .toJS()
            .filter((item) => !item.deleted)
            .filter((item) => item.barn === true)
            .reduce((unique, item) => {
                if (useTitle) {
                    const index = unique.findIndex(
                        (uniqueItem) => uniqueItem.titleArticleId === item.titleArticleId
                    );

                    return index < 0 ? [...unique, item] : unique;
                }

                return [...unique, item];
            }, [])
            .slice(0, env.HISTORY_UPPER_LIMIT)
            .map((continueWatchingItem) => ({
                id: continueWatchingItem[useTitle ? 'titleArticleId' : 'videoId'],
                progressSeconds: parseInt(continueWatchingItem.position, 10) || 0,
            }));
    }

    const [keepWatchingItems, setKeepWatchingItems] = useState(null);
    const [loadingItems, setItemsLoading] = useState(false);
    const [fetchError, setFetchError] = useState(null);

    // Use fetch API to get data for this component in order to invoke POST request
    useEffect(() => {
        if (history && history.length > 0 && keepWatchingItems === null && loadingItems === false) {
            setItemsLoading(true);
            fetchContinueWatchItems(history)
                .then((data) => {
                    setItemsLoading(false);
                    if (useTitle) {
                        const filterdItems = data.data.keepWatching.items.filter((item) => {
                            return item.item.associatedContent.length > 0;
                        });
                        data.data.keepWatching.items = filterdItems;
                        setKeepWatchingItems(data);
                    } else {
                        setKeepWatchingItems(data);
                    }
                })
                .catch((err) => {
                    setItemsLoading(false);
                    setFetchError(err);
                });
        }
    }, [loadingItems, history, keepWatchingItems, useTitle]);

    if (
        !continueWatchingIsActive ||
        !continueWatchingItems ||
        continueWatchingItems.size === 0 ||
        keepWatchingItems === null ||
        fetchError !== null
    ) {
        return null;
    }

    if (loadingItems) {
        return (
            <section className="play_videolist-group play_videolist-group--with-divider">
                <div className="play_videolist__header-wrapper">
                    <h1 className="play_videolist-section-header__header">Fortsätt titta</h1>
                </div>
                <PlaceHolder nrOfItems={4} />
            </section>
        );
    }

    const items = fromJS(
        transformToContentList(keepWatchingItems.data.keepWatching.items).map((item) => {
            return {
                ...item,
                next: useTitle ? false : item.next,
            };
        })
    );

    const listTracking = {
        listType: 'personlig historik',
        listID: 'fortsatt titta',
    };

    const onItemClick = createListTrackingOnClick(listTracking);

    const headerText = keepWatchingItems.data.keepWatching.name;

    return (
        <ContentList
            id="pers"
            items={items.toJS()}
            continueWatchingItems={continueWatchingItems}
            continueWatchingIsActive={continueWatchingIsActive}
            headerText={headerText}
            expandable={false}
            regTestSpec="continue-watching"
            onItemClick={onItemClick}
        />
    );
};

const mapStateToProps = (state) => {
    return {
        continueWatchingItems: continueWatchingItemsSelector(state),
        continueWatchingIsActive: continueWatchingActiveSelector(state),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        deleteContinueWatchingListItems: (deletedItems) =>
            dispatch(deleteContinueWatchingListContents(deletedItems)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ContinueWatchingList);
